import React from 'react'
import VideoListIcon from './VideoListIcon'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Modal } from 'react-bootstrap'
import VideoListContent from './VideosListContent'

class VideoListMobile extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }

    this.closeModal = this.closeModal.bind(this)
  }

  closeModal () {
    this.setState({ active: false })
  }

  render () {
    const videoListMobileClasses = classNames('video-list-mobile', {
      active: this.state.active,
      shift: this.props.controlsShowing
    })

    const videoModalCloseClasses = classNames('close', {
      'white-background': this.props.type === 'series'
    })

    return (
      <div className={videoListMobileClasses}>
        <div
          className='entry-hover'
          onClick={() => {
            this.setState({ active: true })
          }}
        >
          <VideoListIcon type={this.props.type} />
        </div>
        <Modal
          className='modal centered video-modal'
          show={this.state.active}
          onHide={() => {
            this.setState({ active: false })
          }}
        >
          <div className='modal-header'>
            <button
              className={videoModalCloseClasses}
              onClick={this.closeModal}
            >
              <span>&times;</span>
            </button>
          </div>
          <VideoListContent {...this.props} />
        </Modal>
      </div>
    )
  }
}

VideoListMobile.propTypes = {
  type: PropTypes.string
}

export default VideoListMobile
